var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75C14.07 15.75 15.75 14.07 15.75 12V6C15.75 3.93 14.07 2.25 12 2.25C9.93 2.25 8.25 3.93 8.25 6V12C8.25 14.07 9.93 15.75 12 15.75ZM9.75 6C9.75 4.76 10.76 3.75 12 3.75C13.24 3.75 14.25 4.76 14.25 6V12C14.25 13.24 13.24 14.25 12 14.25C10.76 14.25 9.75 13.24 9.75 12V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.25C17.59 9.25 17.25 9.59 17.25 10V12C17.25 14.9 14.89 17.25 12 17.25C9.11 17.25 6.75 14.9 6.75 12V10C6.75 9.59 6.41 9.25 6 9.25C5.59 9.25 5.25 9.59 5.25 10V12C5.25 15.47 7.88 18.33 11.25 18.71V20.25H10C9.59 20.25 9.25 20.59 9.25 21C9.25 21.41 9.59 21.75 10 21.75H14C14.41 21.75 14.75 21.41 14.75 21C14.75 20.59 14.41 20.25 14 20.25H12.75V18.71C16.12 18.34 18.75 15.47 18.75 12V10C18.75 9.59 18.41 9.25 18 9.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic_icon.676ca7496216cb69f4cd8018c3f3e01e.svg";
export { ForwardRef as ReactComponent };